import request from '@/router/axios'

export function fetchRequestList (query) {
  return request({
    url: `/post/admin/circles/0/requests/page`,
    method: 'get',
    params: query
  })
}

export function approveRequest (id) {
  return request({
    url: `/post/circles/0/requests/approve/${id}`,
    method: 'put'
  })
}

export function rejectRequest (id) {
  return request({
    url: `/post/circles/0/requests/reject/${id}`,
    method: 'put'
  })
}
